var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-analysis"},[_c('h4',{staticClass:"mt-2"},[_vm._v("Audio Analysis")]),_c('svg',{attrs:{"xwidth":"1000","xheight":"200","viewBox":"0 0 1000 200"}},[_c('polygon',{attrs:{"points":_vm.points}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }